import React, { Fragment } from 'react';

import { useSessionStore } from 'session/useSessionStore';

export type GeopostLogoProps = {
    maxWidth?: number,
    maxHeight?: number,
};

export const GeopostLogo = ({ maxWidth = 100, maxHeight = 32 } : GeopostLogoProps) => {
    const logoPath = useSessionStore(state => state.tenantConfiguration?.layout.logoPath);
    const logoClickLink = useSessionStore(state => state.tenantConfiguration?.logoClickLink);
    return (
        <Fragment>
            {
                logoPath ? <a title={logoClickLink ? 'Open the home page in another tab' : ''} href={logoClickLink ? logoClickLink : '#'} target='_blank' rel="noreferrer">
                    {
                        window.location.href.indexOf('skkmigas') === -1 ?
                            <img src={logoPath} style={{maxWidth, maxHeight}}/>
                            :
                            <img src={logoPath} style={{maxWidth, maxHeight, backgroundColor: 'white', borderRadius: '5px', padding: '5px'}}/>
                    }
                </a> : null
            }
        </Fragment>
    );
};